export default __webpack_public_path__ + "static/media/aboutImg.3481f60e.jpeg";